import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Typography, Paper } from '@mui/material';
import { ScreenFrame } from '../PrototypeShared';

export default function RecallDetailScreen() {
  const { id } = useParams();

  return (
    <ScreenFrame
      title={`Recall ${id}`}
      actions={
        <>
          <Button component={Link} to="/prototype/recalls" variant="outlined" size="small">Back to list</Button>
          <Button component={Link} to={`/prototype/recalls/${id}/edit`} variant="contained" size="small">Edit</Button>
        </>
      }
    >
      <Paper sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">Product</Typography><Typography>Demo lot impact</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Status</Typography><Typography>Open</Typography>
      </Paper>
    </ScreenFrame>
  );
}
